import { all, select, takeEvery, fork, put } from 'redux-saga/effects'

// action
import {
	mainActions,
	adminActions,
	configActions,
	routeActions,
} from '@redux/store/index'

// lib
import { Logger } from '@utils'
import { firstMainTap, firstAdminTap } from '@redux/store/core/config.store'

// type
import type { ConfigStateType, MenuType, TabType } from '@redux/types'

function* getMenu() {
	try {
		yield put(adminActions.TRIGGER_GET_MENU_LIST(true))
	} catch (error) {
		Logger.warn(error)
	}
}

function* menuSaga() {
	try {
		const mode: ConfigStateType['mode'] = yield select(state => state.config.mode)
		const configTabList: TabType[] = yield select(state => state.config.tabList)
		const menu: MenuType[] = yield select(state => state.main.menu)
		const defaultTab: TabType = mode === 'main' ? firstMainTap : firstAdminTap

		const firstMenu: MenuType = menu.filter(aMenu => aMenu.id.startsWith('OP-'))[0]
		const firstTab: TabType =
			firstMenu !== undefined
				? {
						id: firstMenu.id,
						name: firstMenu.name,
						path: firstMenu.to ?? '',
						i18n: firstMenu.i18n ?? [],
				  }
				: {
						id: 'main',
						name: 'Main',
						path: '/main/empty',
						i18n: [],
				  }
		const newTabList: TabType[] =
			firstMenu !== undefined ? [defaultTab, { ...firstTab }] : []

		const isMainMode: boolean = mode === 'main'
		const isDefaultConfigTabList: boolean =
			configTabList.length === 1 && configTabList[0].id === 'home'

		// 2026-09-28: 로그인 착지는 홈(대시보드)이다. 예전에는 첫 메뉴로 바로 보냈다 — 홈이 빈 화면이었을 때의 판단.
		if (isMainMode && isDefaultConfigTabList) {
			yield put(configActions.TAB_LIST(newTabList))
		}

		if (mode === 'main') {
			// 이미 /main/* 화면(딥링크·새로고침)에 서 있으면 그대로 둔다. 로그인 흐름(/auth/*)에서만 홈으로 간다
			const currentPath: string = yield select(state => state.route.currentPath)
			const isOnMainPage: boolean =
				currentPath.startsWith('/main/') && currentPath !== '/main/empty'
			if (!isOnMainPage) {
				yield put(routeActions.NAVIGATE_PATH('/main/home'))
			}
		}

		yield put(configActions.TAB_LIST([defaultTab]))
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(mainActions.TRIGGER_GET_MENU, getMenu)
	yield takeEvery(mainActions.MENU, menuSaga)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
